module Eseebase {
    export interface IFilterChipsScope extends ng.IScope {
        ngModel: ModelFilterViewModel;
        isGroupingOrFilterSelected: Function;
        deleteFilter: Function;
        deleteGrouping: Function;
        onChanged: Function;
        expandFilters: Function;
        getCompanyNames: Function;
        getAssociationNames: Function;
        getDepartmentNames: Function;
        statusChanged: Function;
        modelTypeChanged: Function;
        loadOrganizations: Function;
        activeTab: string;
        isFileOverview: boolean;
        translateArray: Function;
        hidePrefix: Function;
    }

    export class FilterChipsDirective {
        public link: (scope: IFilterChipsScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/filter-chips.html';
        public scope = {
            ngModel: '=',
            onChanged: '&',
            activeTab: '='
        };
        public restrict = 'E';
        public require: string;
        public replace: any;

        constructor(private buildingService: BuildingService, private organizationService: OrganizationService, private $q: ng.IQService, private $timeout: ng.ITimeoutService, private $rootScope: ng.IRootScopeService, private textService: TextService, private organizationSettingsService: OrganizationSettingsService)
        {
            var vm = this;
            FilterChipsDirective.prototype.require = '?ngModel';
            FilterChipsDirective.prototype.replace = 'true';
            FilterChipsDirective.prototype.link = (scope: IFilterChipsScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                var organizations: OrganizationalUnitViewModel[];
                scope.isFileOverview = window.location.hash.substr(0, '#!/overview'.length) == '#!/overview';

                scope.isGroupingOrFilterSelected = function () {
                    if (scope.ngModel == null || scope.ngModel.isEmpty()) {
                        return false;
                    }
                    switch (scope.activeTab)
                    {
                        case 'indoor':
                            return scope.ngModel.indoorBuildingPartType.groupBy;
                        case 'outdoor':
                            return scope.ngModel.category.groupBy;
                        case 'sim':
                            return scope.ngModel.simFamilyTypeName.groupBy;
                    }
                    return true;
                }

                scope.expandFilters = function (evt: JQueryEventObject) {
                    $rootScope.$broadcast('filter-open');
                    evt.stopImmediatePropagation();
                    evt.stopPropagation;
                    evt.cancelBubble = true;
                }

                scope.deleteFilter = function (filters: ModelFilterItemViewModel[])
                {
                    for (var f of filters) {
                        f.values = null;
                    }
                    vm.buildingService.saveFilters(scope.ngModel);
                    $rootScope.$broadcast('filter-delete');
                    scope.onChanged();
                }

                scope.deleteGrouping = function (filter: ModelFilterItemViewModel) {
                    filter.groupBy = false;
                    vm.buildingService.saveFilters(scope.ngModel);
                    $rootScope.$broadcast('filter-delete');
                    scope.onChanged();
                }

                scope.hidePrefix = function (): boolean {
                    if (organizationSettingsService.uiStyling != null)
                    {
                        return organizationSettingsService.uiStyling.filterChipsHidePrefix();
                    }
                    return false;
                }

                scope.loadOrganizations = function () {
                    organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                        organizations = response;
                    });
                }
                scope.loadOrganizations();

                scope.getAssociationNames = function (orgNumbers: string[]) {
                    if (orgNumbers != null) {
                        if (organizations == null) {
                            return orgNumbers.join(',');
                        }
                        else {
                            var result = [];
                            for (var orgNumber of orgNumbers) {
                                var organization = organizations.filter(c => c.id == orgNumber);
                                if (organization != null && organization.length > 0) {
                                    result.push(organization[0].name);
                                }
                            }
                            return result.join(',');
                        }
                    }

                    return null;
                }

                scope.getDepartmentNames = function (orgNumbers: string[]) {
                    if (orgNumbers != null) {
                        if (organizations == null) {
                            return orgNumbers.join(',');
                        }
                        else {
                            var result = [];
                            for (var companyNumber of orgNumbers) {
                                for (var ass of organizations) {
                                    if (ass != null && ass.children != null) {
                                        var department = ass.children.filter(c => c.id == companyNumber);
                                        if (department != null && department.length > 0) {
                                            result.push(department[0].name);
                                        }
                                    }
                                }
                            }
                            return result.join(',');
                        }
                    }

                    return null;
                }

                scope.translateArray = function (values: string[]) {
                    var result = '';
                    for (var v of values) {
                        result += vm.textService.translate(v) + ',';
                    }
                    if (result != '') {
                        result = result.substring(0, result.length - 2);
                    }
                    return result;
                }

                scope.statusChanged = function () {
                    vm.buildingService.saveFilters(scope.ngModel);
                    scope.onChanged();
                }

                scope.modelTypeChanged = function () {
                    vm.buildingService.saveFilters(scope.ngModel);
                    scope.onChanged();
                }
            };
        }

        public static Factory() {
            var directive = (buildingService: BuildingService, organizationService: OrganizationService, $q: ng.IQService, $timeout: ng.ITimeoutService, $rootScope: ng.IRootScopeService, textService: TextService, organizationSettingsService: OrganizationSettingsService) => {
                return new FilterChipsDirective(buildingService, organizationService, $q, $timeout, $rootScope, textService, organizationSettingsService);
            };

            directive['$inject'] = ['BuildingService', 'OrganizationService', '$q', '$timeout', '$rootScope', 'TextService', 'OrganizationSettingsService'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('filterChips', FilterChipsDirective.Factory());
}